import Notification from './Notification';
import NotificationV2 from './Notification.fave_comment_tooltip';
import NotificationContainer from './Notification.container';
import { withFeatureBranch } from '../../redux/flags';
export default withFeatureBranch({
    fave_comment_tooltip: NotificationV2,
})(NotificationContainer(Notification));
//# sourceMappingURL=index.js.map